import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import get from 'lodash.get';
import { parseCategoryID } from '../../../utils';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next'

export default function RelatedSeries(props) {
  const { t } = useTranslation();
  const { series } = props;
  const [swiper, setSwiper] = useState(null);

  const initSwiper = (s) => {
    setSwiper(s);
    SwiperCore.use([Navigation]);
    const prev = document.getElementById('prevbutton');
    const next = document.getElementById('nextbutton');
  };

  return (
    <Swiper
      onSwiper={(swiper) => initSwiper(swiper)}
      className="r-video"
      slidesPerView={1}
      spaceBetween={10}
      navigation={{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }}
    >
      <div className="swiper-wrapper">
        {series &&
          series.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((s, i) => (
            <SwiperSlide key={s.id} className="swiper-slide">
              <Link to={`/series/${s.id}`} style={{ color: 'white', textDecoration: 'none' }}>
                <div className="video-wrapper">
                  <div className="play">
                    <span className="icon-playbuttonsmall"></span>
                  </div>
                  <div className="medias">
                    {get(s, 'seriePicture.uri', '') &&
                      <span
                        style={{
                          backgroundImage: `url(${
                            process.env.REACT_APP_API_URL
                          }/storage/serie-picture/${get(s, 'seriePicture.uri', '')}`,
                        }}
                      />
                    }
                  </div>
                </div>
                <div className="video-infos">
                  <div className="video-category">
                    <span className={`cat ${parseCategoryID(s.category).categoryShorthand}`}>
                      {t(parseCategoryID(s.category)?.categoryTranslationKey)}
                    </span>{' '}
                    {(s.videos.length || 0) > 1 ? t('XEpisodes', { num: s.videos.length || 0}) : t('XEpisode', {num: s.videos.length || 0})}
                  </div>
                  <div className="video-title" title={s.title}>{s.title}</div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
      </div>
      <div id="prevbutton" className="swiper-button-prev" onClick={() => swiper.slidePrev()}></div>
      <div id="nextbutton" className="swiper-button-next" onClick={() => swiper.slideNext()}></div>
    </Swiper>
  );
}
